import { useCallback, useEffect, useState } from 'react';
import {
    activeProfileHintId,
    dismissProfileHint,
    ProfileHintFields,
    ProfileHintId,
    ProfileHintSnooze,
    readProfileHintSnoozes,
} from './profileHints';

export function useProfileHints(
    userId: string | null | undefined,
    profile: ProfileHintFields | null,
) {
    const [snoozed, setSnoozed] = useState<ProfileHintSnooze[]>(() =>
        userId ? readProfileHintSnoozes(userId) : []
    );
    const [snoozedFor, setSnoozedFor] = useState<string | null>(userId ?? null);

    useEffect(() => {
        const nextUserId = userId ?? null;
        if (nextUserId === snoozedFor) return;
        setSnoozed(nextUserId ? readProfileHintSnoozes(nextUserId) : []);
        setSnoozedFor(nextUserId);
    }, [userId, snoozedFor]);

    const activeId = profile && userId && snoozedFor === userId
        ? activeProfileHintId(profile, snoozed)
        : null;

    const dismiss = useCallback((id: ProfileHintId) => {
        if (!userId) return;
        setSnoozed(dismissProfileHint(userId, id));
    }, [userId]);

    const isActive = useCallback(
        (id: ProfileHintId) => activeId === id,
        [activeId],
    );

    return { isActive, dismiss };
}
